import { getCurrentSkuIdForProduct, getHighestProductLevelSkuIdsByProductLine, getProductForSkuId, getSkuIdIsHub } from 'pricing-pages-lib/utils/productsUtils';
import { CORE_SEATS_INCLUDED_STARTER } from 'self-service-api/constants/ApiNames';
import { getProductsFromProductInventory } from './productInventoryUtils';
const NON_ONBOARDING_API_NAMES = [CORE_SEATS_INCLUDED_STARTER];
export const getRequiredOnboardingSkuId = (state, {
  skuId,
  removeNonOnboardingApiNames = true
}) => {
  const {
    requiredOnboarding
  } = state;
  const {
    apiName
  } = getProductForSkuId(state, {
    skuId
  });

  if (!requiredOnboarding[apiName] || !requiredOnboarding[apiName].onboardingRequired) {
    return null;
  }

  const {
    onboardingApiName
  } = requiredOnboarding[apiName];

  if (removeNonOnboardingApiNames && NON_ONBOARDING_API_NAMES.includes(onboardingApiName)) {
    return null;
  }

  return getCurrentSkuIdForProduct(state, {
    apiName: onboardingApiName
  });
};
export const getIsStarterCoreSeatRequiredForSkuIds = (state, {
  skuIds
}) => {
  const highestProductLevelSkuIdsByProductLine = getHighestProductLevelSkuIdsByProductLine(state, {
    skuIds
  });
  const skuIdsToUse = Object.values(highestProductLevelSkuIdsByProductLine);
  const requiredOnboardingSkuIds = skuIdsToUse.map(skuId => getRequiredOnboardingSkuId(state, {
    skuId,
    removeNonOnboardingApiNames: false
  }));
  const coreSeatsIncludedStarterSkuId = getCurrentSkuIdForProduct(state, {
    apiName: CORE_SEATS_INCLUDED_STARTER
  });
  return Boolean(requiredOnboardingSkuIds.find(skuId => skuId && skuId === coreSeatsIncludedStarterSkuId));
};
export const getIsStarterCoreSeatRequired = (state, {
  productConfigurations
}) => {
  const hubSkuIds = productConfigurations.filter(prodConfig => {
    const {
      skuId
    } = prodConfig;
    return getSkuIdIsHub(state, {
      skuId
    });
  }).map(({
    skuId
  }) => skuId);
  const ownedHubSkuIds = getProductsFromProductInventory(state).map(({
    currentSkuId
  }) => currentSkuId).filter(skuId => getSkuIdIsHub(state, {
    skuId
  }));
  return getIsStarterCoreSeatRequiredForSkuIds(state, {
    skuIds: [...hubSkuIds, ...ownedHubSkuIds]
  });
};